import React from 'react';
import './HourglassLoader.css';

/**
 * HourglassLoader — Ampulheta animada nas cores da MarketingPro.
 * Para loading geral de páginas / dados (NÃO para criação IA — use GlobalLoader/Eddy).
 *
 * Variantes:
 *   <HourglassLoader />                         → overlay full-page
 *   <HourglassLoader variant="inline" />         → dentro de cards/seções
 *   <HourglassLoader variant="btn" />            → dentro de botões (pequeno)
 */
const HourglassCore = () => (
  <div className="hourglassBackground">
    <div className="hourglassContainer">
      <div className="hourglassCurves" />
      <div className="hourglassCapTop" />
      <div className="hourglassGlassTop" />
      <div className="hourglassSand" />
      <div className="hourglassSandStream" />
      <div className="hourglassCapBottom" />
      <div className="hourglassGlass" />
    </div>
  </div>
);

const HourglassLoader = ({ variant = 'overlay', message }) => {
  if (variant === 'btn') {
    return (
      <span className="hourglass-btn">
        <HourglassCore />
      </span>
    );
  }

  if (variant === 'inline') {
    return (
      <div className="hourglass-inline">
        <HourglassCore />
        {message && <p className="hourglass-message">{message}</p>}
      </div>
    );
  }

  // overlay (default)
  return (
    <div className="hourglass-overlay">
      <HourglassCore />
      {message && <p className="hourglass-message">{message}</p>}
    </div>
  );
};

export default HourglassLoader;
